// extracted by mini-css-extract-plugin
module.exports = {"footer":"a10a3f92e9--footer--3yJzU","info":"a10a3f92e9--info--2QG0S","error":"a10a3f92e9--error--Dog5_"};